import { RouterProvider } from '@tanstack/react-router'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { FullPageSpinner, ThemeProvider, ToastProvider } from '@najah/ui'
import { AuthProvider, useAuth } from './lib/auth'
import { LoginPage } from './routes/LoginPage'
import { ChangePasswordScreen } from './routes/ChangePasswordScreen'
import { router } from './router'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      // إعادة المحاولة لا تفيد مع أخطاء الصلاحيات أو انتهاء الجلسة
      retry: (failureCount, error) => {
        const status = (error as { status?: number }).status
        if (status && status >= 400 && status < 500) return false
        return failureCount < 2
      },
      refetchOnWindowFocus: false,
    },
  },
})

function AuthGate() {
  const { user, isRestoring } = useAuth()

  if (isRestoring) return <FullPageSpinner label="جارٍ استعادة الجلسة…" />
  if (!user) return <LoginPage />
  // الخادم يرفض كل مسار آخر حتى تتغيّر كلمة المرور المؤقّتة
  if (user.mustChangePassword) return <ChangePasswordScreen />

  return <RouterProvider router={router} />
}

export function App() {
  return (
    <ThemeProvider>
      <ToastProvider>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <AuthGate />
          </AuthProvider>
        </QueryClientProvider>
      </ToastProvider>
    </ThemeProvider>
  )
}
